
const MODULE_TIPOS = ["module_unit"]
const ASSEMBLY_TIPOS = ["steel_cage", "timber_panel", "concrete_slab", "steel_panel"]
const PART_TIPOS = [
    "timber",
    "plate",
    "steel",
    "accesories",


    // THIS IS OLD, PART TIPOS ARE NOT CATS NOW. PART TIPOS ARE BRANCHES!!
    // "top_rail",
    // "bottom_rail",
    // "extra_top_rail",
    // "extra_bottom_rail",
    // "frame_nail",
    // "frame_nail_single",
    // "frame_saw",
    // "plate_nail",
    // "milling",
    // "wood",
    // "plate",
    // "core_plate",
    // "plate_screw",
    // "sawing",
    // "glue",
    // "brick",
    // "unknown",
]

// Production tipos are the ones that go to the assembly/module viewer
const PRODUCTION_TIPOS = [...MODULE_TIPOS, ...ASSEMBLY_TIPOS]
// Logistics tipos are part branches (timber, plate, steel, accesories)
const LOGISTICS_TIPOS = [...PART_TIPOS]

function hasLogisticsTipos(tipos) {
    return tipos.some(t => LOGISTICS_TIPOS.includes(t))
}

function hasProductionTipos(tipos) {
    return tipos.some(t => PRODUCTION_TIPOS.includes(t))
}

function hasOnlyLogisticsTipos(tipos) {
    if (tipos.length === 0) return false
    return tipos.every(t => LOGISTICS_TIPOS.includes(t))
}


export { MODULE_TIPOS, ASSEMBLY_TIPOS, PART_TIPOS, PRODUCTION_TIPOS, LOGISTICS_TIPOS, hasLogisticsTipos, hasProductionTipos, hasOnlyLogisticsTipos }